var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1306(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 107 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0556641,
    y: 0.592773,
    width: 106,
    height: 71,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1885 47.1699H25.4294V43.0223L22.1885 43.7207V47.1699Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1467 40.9639C43.0548 41.454 42.9262 41.8644 42.7546 42.1953C42.5831 42.5261 42.3687 42.8324 42.1114 43.1142C41.7315 43.5125 41.2659 43.8372 40.7146 44.0761C40.1632 44.315 39.5689 44.4376 38.9256 44.4376C38.2823 44.4376 37.6881 44.315 37.1367 44.0761C36.5853 43.8372 36.1197 43.5125 35.7398 43.1142C35.4764 42.8324 35.262 42.5261 35.0966 42.1953C34.9373 41.8828 34.8148 41.4907 34.7229 41.0312L31.5371 41.7113C31.6658 42.3178 31.8496 42.8876 32.1008 43.4083C32.3826 43.9903 32.7808 44.5417 33.3015 45.0624C34.0428 45.8038 34.8822 46.3674 35.8134 46.7595C36.7446 47.1516 37.78 47.3476 38.9256 47.3476C40.0713 47.3476 41.1066 47.1516 42.0501 46.7595C42.9936 46.3674 43.8329 45.8038 44.5742 45.0624C45.095 44.5417 45.4932 43.9903 45.775 43.4083C46.0568 42.8263 46.2529 42.1953 46.3754 41.5152C46.4979 40.8352 46.5653 40.0755 46.5837 39.2484C46.5837 39.0034 46.5959 38.7522 46.5959 38.4888L43.3183 39.1872C43.2877 39.8856 43.2264 40.4737 43.1406 40.9577L43.1467 40.9639Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.623 47.17H52.8701V38.7523H57.7406C58.7821 38.7523 59.7256 38.5869 60.5649 38.256C61.4042 37.9252 62.1271 37.4719 62.7275 36.9021C63.3279 36.3323 63.7874 35.6523 64.1121 34.8559C64.1305 34.813 64.1366 34.7701 64.155 34.7333L49.6292 37.8394V47.1639L49.623 47.17Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3281 47.1701H70.5751V33.3672L67.3281 34.0656V47.1701Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.957 29.8627L82.9197 30.7265L81.4187 33.4405L80.2485 31.3024L77.1608 31.9579L79.6788 36.2035L73.0684 47.1699H76.7932L81.4187 38.9666L86.0809 47.1699H89.8365L83.1954 36.2035L86.957 29.8627Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3231 25.7765H16.2949V28.6865H22.1886V42.4649L25.4295 41.7726V28.6865H31.3231V25.7765Z",
    fill: "url(#paint0_linear_2092_57377)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3822 31.4252C46.2597 30.7451 46.0636 30.1141 45.7818 29.5321C45.5 28.9501 45.1018 28.3987 44.581 27.8779C43.8397 27.1366 43.0004 26.573 42.0569 26.1809C41.1134 25.7888 40.0719 25.5928 38.9324 25.5928C37.7929 25.5928 36.7514 25.7888 35.8202 26.1809C34.8889 26.573 34.0496 27.1366 33.3083 27.8779C32.7876 28.3987 32.3893 28.9501 32.1075 29.5321C31.8257 30.1141 31.6236 30.7451 31.4888 31.4252C31.3601 32.1052 31.2804 32.8649 31.2621 33.6919C31.2437 34.5251 31.2314 35.4502 31.2314 36.4734C31.2314 37.4965 31.2437 38.4216 31.2621 39.2548C31.2743 39.6959 31.2988 40.1125 31.3417 40.5107L34.5642 39.8245C34.5459 39.6162 34.5336 39.4018 34.5213 39.169C34.4907 38.4583 34.4785 37.5639 34.4785 36.4795C34.4785 35.3951 34.4907 34.5006 34.5213 33.79C34.552 33.0793 34.6133 32.4789 34.699 31.9888C34.7909 31.4987 34.9196 31.0882 35.0911 30.7574C35.2626 30.4265 35.4771 30.1202 35.7344 29.8384C36.1143 29.4402 36.5798 29.1155 37.1312 28.8765C37.6826 28.6376 38.2769 28.5151 38.9201 28.5151C39.5634 28.5151 40.1577 28.6376 40.7091 28.8765C41.2605 29.1155 41.7261 29.4402 42.1059 29.8384C42.3632 30.1202 42.5838 30.4265 42.7492 30.7574C42.9207 31.0882 43.0494 31.4987 43.1413 31.9888C43.2332 32.4789 43.2945 33.0793 43.319 33.79C43.3496 34.5006 43.3618 35.3951 43.3618 36.4795C43.3618 37.0125 43.3618 37.4965 43.3496 37.9437L46.6027 37.2453C46.6027 36.9941 46.6027 36.7429 46.6027 36.4795C46.6027 35.4564 46.5905 34.5313 46.5721 33.6981C46.5537 32.8649 46.4802 32.1113 46.3638 31.4313L46.3822 31.4252Z",
    fill: "url(#paint1_linear_2092_57377)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7275 27.6207C62.1271 27.0509 61.4042 26.5975 60.5649 26.2667C59.7256 25.9359 58.7821 25.7705 57.7406 25.7705H49.623V36.5959L53.2928 35.8117H52.8701V28.6867H57.5568C58.6963 28.6867 59.6153 28.9991 60.3076 29.6179C60.9999 30.2367 61.343 31.1189 61.343 32.2645C61.343 33.0303 61.1714 33.6613 60.8651 34.1882L64.4981 33.4102C64.5532 33.0426 64.59 32.6566 64.59 32.2584C64.59 31.3394 64.4307 30.4756 64.1121 29.673C63.7935 28.8705 63.3279 28.1843 62.7275 27.6145V27.6207Z",
    fill: "url(#paint2_linear_2092_57377)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3281 32.8096L70.5751 32.1173V25.7765H67.3281V32.8096Z",
    fill: "url(#paint3_linear_2092_57377)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4854 25.7765L76.4996 30.8492L79.6302 30.1814L77.2163 25.7765H73.4854Z",
    fill: "url(#paint4_linear_2092_57377)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6584 25.7765L83.7041 29.3053L87.8088 28.4292L89.3833 25.7765H85.6584Z",
    fill: "url(#paint5_linear_2092_57377)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.557 35.8116C58.6965 35.8116 59.6155 35.5052 60.3078 34.8926C60.5344 34.6904 60.7121 34.4515 60.8653 34.188L53.293 35.8054H57.557V35.8116Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2092_57377",
    x1: 16.9321,
    y1: 34.1207,
    x2: 89.1324,
    y2: 34.1207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2092_57377",
    x1: -403.355,
    y1: 33.0487,
    x2: -402.742,
    y2: 33.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2092_57377",
    x1: -403.354,
    y1: 31.1863,
    x2: -402.742,
    y2: 31.1863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2092_57377",
    x1: -403.354,
    y1: 29.293,
    x2: -402.741,
    y2: 29.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2092_57377",
    x1: -403.353,
    y1: 28.3128,
    x2: -402.741,
    y2: 28.3128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2092_57377",
    x1: -403.356,
    y1: 27.5409,
    x2: -402.743,
    y2: 27.5409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C60000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1306);
export default __webpack_public_path__ + "static/media/1306.f5ca252863bfca0b4113a07a53b71f6d.svg";
export { ForwardRef as ReactComponent };